<template>
  <div class="d-flex flex-column align-items-center justify-content-center mt-5 mb-5" 
  :class=" defaultSite.isStudent ? 'container-fluid m-0' : 'container-fluid' ">
    <progress-bar v-if="!isKBInternal" :defaultSite="defaultSite" :step1Active="isActive"></progress-bar>
    <div role="main" class="col-12 col-lg-10 p-3 bg-light" >
      <div class="row justify-content-center">
        <div class="col-12 col-xxl-6 order1 pe-xxl-5">
          <hr class="d-sm-none" />
                         <img v-if="!step3Active"  class="img-fluid float-end d-xxl-none" src="https://cdn.trailfinders.com/3dauu2dhtm_travel-insurance-rating-category-and-year-5-colour-rgb.png?width=80" />
          <div v-if="tripDetails.quoteType !== 'BACKPACKER'" class="p-3">   
           
          <h2 class="text-center">Trailfinders Travel Insurance</h2>
          
          <h3 class="text-center">Get an instant quote and buy online</h3>
          <h6 class="text-center" v-if="defaultSite.domain === 'ie'">
            Our carefully crafted policies offer wide-ranging cover and great value for money. Trusted since 1970, <b>Trailfinders Single Trip</b> and <b>Trailfinders Annual Multi-Trip</b> policies include €6,000pp cancellation cover and €10 million medical and repatriation expenses.
          </h6>
          <h6 class="text-center" v-if="defaultSite.domain !== 'ie'">
          Our carefully crafted policies offer wide-ranging cover and great value for money. Trusted since 1970, <b>Trailfinders Single Trip</b> and <b>Trailfinders Annual Multi-Trip</b> policies include {{ cover.uk.cancellation }}pp cancellation cover and £10 million medical and repatriation expenses, whilst our <b>Trailfinders Backpacker policy</b> is designed for flexible independent travellers aged 30 and under with unique features for extended multi-country adventures. 
          </h6>
        </div>
        <div v-else class="text-center p-3">
          <h5 v-if="defaultSite.domain !== 'ie'" >
            Trailfinders Backpacker travel insurance offers wide ranging cover specifically designed for flexible independent travel and includes up to 
            £10-million emergency medical and repatriation expenses and {{ cover.ukBackpacker.cancellation }}pp cancellation cover.
          </h5>
          <!-- <h5 v-else>
            Trailfinders Backpacker travel insurance offers wide ranging cover specifically designed for flexible independent travel and includes up to 
            €10-million emergency medical and repatriation expenses and €2,000pp cancellation cover.
          </h5> -->
        </div>

          <div class="bg-light p-3">
            <!-- form -->
            <form @submit="onSubmit" name="form" class="bg-light">
              <section>
                <div class="form-group">
                  <label for="ORIGINDISPLAY">
                    Permanent Country of Residence
                  </label>
                  <div class="form-group d-flex mb-3">
                    <select id="ORIGINDISPLAY" class="p-3 text-dark w-100 "
                      v-model="tripDetails.residence">
                      <option class="text-dark" v-for="country in setCountries" :value="country.value"
                        :key="country.name">{{ country.name }}
                      </option>
                    </select>
                    <div class="tf-vue-bg-grey-darker">
                      <a href="javascript:void(0)"
                        class="text-white text-decoration-none d-flex align-items-center justify-content-center w-100 h-100 p-3 px-4"
                        id="area-pop" @click="toggleResidence">?</a>
                    </div>
                  </div>
                  <p v-if="showResInfo">
                    <em class="fw-bold" v-if="defaultSite.domain === 'ie'">
                      You must be a resident of the Republic of Ireland (Eire) to purchase a policy.  If you are a resident of Northern Ireland, please click <a href="https://www.trailfinders.com/insurance">here</a> to purchase our UK policy. 
                    </em>
                    <em class="fw-bold" v-else>
                      You must be a resident of the United Kingdom, Channel Islands or Isle of Man to purchase a policy.
                    </em>
                  </p>
                </div>
              </section>

              <section id="trip-single">
                <div>
                  <label for="DESTINATION">Travelling To</label>
                  <div class="d-flex mb-3">
                    <select class="w-100 text-dark p-3" name="DESTINATION"
                      v-model="$v.destinationSingle.$model" id="DESTINATION"
                      :state="tripDetails.quoteType === 'SINGLEG' && validateDestination('destinationSingle')">
                      <option v-for="destination in destinationOptions" class="text-dark" :value="destination.value"
                        :key="destination.name">{{ destination.text }}
                      </option>
                    </select>
                    <destination-modal :destination="quoteSingle.DESTINATION" :domain="defaultSite.domain">
                    </destination-modal>
                  </div>
                </div>
                <p v-if="
                  quoteSingle.DESTINATION === '2' ||
                  quoteSingle.DESTINATION === '3'
                ">
                  Includes a 60 hour stopover anywhere in the world for both
                  outward and return travel.
                </p>
                <div class="mb-5 form-group">
                  <div class="row">
                    <div class="col-12 col-lg-6 mb-4 mb-md-0">
                      <label for="from-datepicker" class="d-block">From:</label>
                      <DatePicker 
                        v-model="$v.dateFrom.$model" 
                        class="flex-grow" 
                        :min-date="new Date()" 
                        :max-date="addYears(new Date(), 1)"
                      >
                        <template v-slot="{ inputValue, inputEvents }">
                          <input
                            autocomplete="off"
                            id="from-datepicker"
                            :value="inputValue"
                            v-on="inputEvents"
                            placeholder='Select Start Date'
                            class="text-gray-700 p-3 w-100"
                          />
                        </template>
                      </DatePicker>
                 
                      <div v-if="$v.dateFrom.$error" class="alert alert-danger">
                        Please select a start date.
                      </div>
                    </div>
                    
                    <div class="col-12 col-lg-6">
                      <label for="to-datepicker" class="d-block">To:</label>
                      <DatePicker 
                        v-model="$v.dateTo.$model" 
                        class="flex-grow" 
                        :min-date="dateFrom ? new Date(dateFrom) : new Date()" 
                        :max-date="policyEndDate()"
                      >
                        <template v-slot="{ inputValue, inputEvents }">
                          <input
                            autocomplete="off"
                            id="to-datepicker"
                            :value="inputValue"
                            v-on="inputEvents"
                            placeholder='Select End Date'
                            class="text-gray-700 p-3 w-100"
                          />
                        </template>
                      </DatePicker>
                      <div v-if="$v.dateTo.$error" class="alert alert-danger">
                        Please select an end date.
                      </div>
                    </div>
                  </div>
                  <span>
                    <small class="pt-3">If you would like to purchase or renew our <b>Annual Multi-Trip policy</b>, please enter the dates of the first trip you would like insured. 
                      Note: The start date for the 12 month period of insurance under the Annual Multi-Trip cannot be more than 90 days from the date of policy issue and the maximum duration per trip is 70 days. </small>
                  </span>

                </div>
          
              </section>

              <!-- PEOPLE & AGES	-->
              <label for="People">Number of People
                <span v-if="tripDetails.quoteType === 'ANNUALG'">(Maximum 2 adults; must be partner/spouse)</span>
                <span v-if="tripDetails.quoteType === 'BACKPACKER'">(Maximum 2 people; aged 14-30)</span>
              </label>
              <div class="form-group mb-3">
                <select v-model="numPeople" class="form-select-lg p-2 w-100" v-if="tripDetails.quoteType !== 'BACKPACKER'"
                  :class="{ 'tf-vue-is-invalid': $v.numPeople.$error }" name="People" id="People"
                  @change="onChangePeople(numPeople)">
                  <option v-for="(option, index) in selectPeople" :key="index" :value="option.value">{{ option.text }}
                  </option>
                </select>
                <select v-model="numPeople" class="form-select-lg p-2 w-100" v-else
                  :class="{ 'tf-vue-is-invalid': $v.numPeople.$error }" name="People" id="People"
                  @change="onChangePeople(numPeople)">
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select>
              </div>

            <div v-if="(peopleAges.length < 10)">
              <div v-for="(person, index) in peopleAges" :key="index" :set="(v = $v.peopleAges.$each[index])"
                class="list-group list-group-flush">
                <label>Current Age of Person {{ index + 1 }}</label>
                <section class="row align-items-center mb-3">
                  <div class="col-12 col-md-3">
                    <div class="form-group mb-2 mb-md-0">
                      <select class="form-select-lg w-100 p-2"
                        :class="{ 'tf-vue-is-invalid': v.AGE.$error }" v-model="person.AGE" :options="getAges"
                        @change="showOver75(person.AGE)" :id="`form-select-${index}`">
                        <option v-for="(age, index) in getAges" :key="index" :id="`form-option-${index}`" :value="age.value">{{ age.text }}</option>
                      </select>
                    </div>
                  </div>
                </section>
              </div>
            </div>

              <div id="kidsonly" v-if="showKids">
                <div>
                  <p class="fw-bold">
                    If you wish to insure children who are not travelling with an
                    adult. Please call <span>{{ defaultSite.telephone }}</span>
                    to arrange for a policy (adult rate will apply).
                  </p>
                </div>
              </div>

              <div v-if="error.over75">
                <div>
                  <p class="fw-bold"><strong>Over 75?</strong></p>
                  <p class="fw-bold">
                    If you are aged 76 or over please call the Trailfinders Vital Health Travel Insurance team on 
                    <a href="tel:01702 671 501">01702 671 501</a>. 
                    This policy has no upper age limit and all medical conditions are considered.
                  </p>
                  <br/>
                  <p class="fw-bold">If you are having difficulty obtaining insurance due to your age, 
                    you may wish to consider one of the specialist providers listed on the Money Advice Service Directory. 
                    You can call them on <a href="tel:0800 138 777">0800 138 777</a> or click 
                    <a href="https://www.moneyhelper.org.uk/en/everyday-money/insurance/travel-insurance-directory">here</a>.
                  </p>
                </div>
              </div>

              <hr v-if="defaultSite.domain !== 'ie'"/>

              <!-----IRELAND SPECIFC--->
              <div class="form-group" v-if="defaultSite.domain === 'ie'">
                <label for="DUBDISCOUNT">25% Discount for Irish Private Heath Insurance</label>
                <div>
                  <select class="form-select-lg w-100 mb-3" id="DUBDISCOUNT" v-model="dubSingle">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                  </select>
                </div>
                <div class="alert alert-info">
                  <p class="fw-bold">
                    I wish to receive a 25% discount off my Premium and confirm
                    my Irish Private Health Insurance provides medical expenses cover
                    overseas. Such Health Insurance will remain in force for the
                    duration of this insurance.
                  </p>
                </div>
              </div>

              <div class="form-group" v-if="defaultSite.domain === 'ie'">
                <label for="DUBREFERENCE">  You must have a current travel booking with Trailfinders in order to purchase travel insurance with us. Please enter your Trailfinders travel booking number here :</label>
                <div>
                  <input 
                    v-model="IERef"
                    class="form-control-lg w-100 mb-3 rounded-0" 
                    id="DUBREFERENCE" 
                    :class="{'tf-vue-is-invalid': $v.IERef.$error}"
                    />
                </div>
                <div class="alert alert-info">
                  <p class="fw-bold">          
            IMPORTANT - If the travel arrangements on the booking number entered do not match with the travel insurance details, your policy will be invalid and any subsequent claims will not be covered.
            Please call us on 01 702 9102 if you prefer to take out your policy with a travel consultant. 
                  </p>
                </div>
               
              </div>

              <!-- Group Discount -->
              <div id="group-discount" v-if="travellingGroup">
                <div>
                  <p class="fw-bold">
                    Please call our Group Travel Department on <a href="tel:02079383858" data-ga4-label="group_travel_specialists" data-ga4-category="text_link">020 7938 3858</a> for a quote including a 10% discount.
                  </p>
                </div>
              </div>

              <!-- SUBMIT BTN -->
              <section class="row">
                <div class="col-md-12">
                  <button class="btn w-100 btn-lg rounded-0" :class="defaultSite.isStudent? 'btn-outline-dark' : 'btn-dark'" type="submit" :disabled="numPeople === '10'">
                    Get a Quote <i class="icon-arrow_right tf-orange ms-2"></i>
                  </button>
                </div>
              </section>

              <div class="alert alert-danger" v-if="formNotValid && error.ageLimit">
                <div class="d-flex justify-content-center">
                  At least one person must be an adult for this quote/policy.
                </div>
              </div>

              <div class="alert alert-danger" v-if="formNotValid && error.backpackerAge">
                <div class="d-flex justify-content-center">
                 This policy is valid for ages between 14 - 30 years only.
                </div>
              </div>

              <div class="alert alert-danger" v-if="formNotValid && error.backpackerAge2">
                <div class="d-flex justify-content-center">
                 The maximum single trip policy duration is 12 months.
                </div>
              </div>

              <div class="alert alert-danger" v-if="formNotValid && error.backpackerDates">
                <div class="d-flex justify-content-center">
                 This policy is valid for durations between 4 days and 2 years.
                </div>
              </div>

              <div class="alert alert-danger" v-if="formNotValid && error.ieRef">
                <div class="d-flex justify-content-center">
                 Please enter a valid Trailfinders reference.
                </div>
              </div>

              <div class="alert alert-danger mt-2" v-if="formNotValid && error.max2Adults">
                <div class="d-flex justify-content-center">
                  Maximum 2 adults permitted on Annual Trip policy. Please note
                  the 2 adults must be partners or spouse
                </div>
              </div>

              <div class="alert alert-danger mt-2" v-if="formNotValid && error.kidsLimit">
                <div class="d-flex justify-content-center">
                  You can include a maximum of 6 children.
                </div>
              </div>
              <div class="alert alert-danger mt-2" v-if="formNotValid && error.only1Kid">
                <div class="d-flex justify-content-center">
                  Only one child can be insured if travelling without an Adult
                  and they will be charged at the Adult rate.
                </div>
              </div>

              <div class="alert alert-danger mt-2" v-if="$v.dateFrom.$error || $v.dateTo.$error">
                <div class="d-flex justify-content-center">
                  Please select dates
                </div>
              </div>

              <div class="alert alert-danger mt-2" v-if="$v.$invalid && $v.$dirty">
                <div class="d-flex justify-content-center">
                  Please fix all required fields
                </div>
              </div>

              <div class="alert alert-danger mt-2" v-if="quoteError">
                <p>There has been an error trying to get the Quote.</p>
                <p>
                  Please contact
                  <strong>{{ defaultSite.telephone }}</strong> for further help.
                </p>
              </div>
            </form>
            <!-- /form -->
          </div>
        </div>

        <div class="col-12 col-xxl-4 order-2 p-0" :class="defaultSite.isStudent && 'bg-light'"  >
          <figure class="has-caption d-none d-xxl-block"> 
            <img v-if="!defaultSite.isStudent"  src="https://cdn.trailfinders.com/images/4502735/tf%20insurance%20booklet%202026_uk%20copy.jpg" 
              alt="Trailfinders Travel Insurance" class="w-100 p-3"/>
              <img v-else src="https://cdn.trailfinders.com/tf_insurance_booklet_2024_uk_front_cover.jpg?width=600" 
              alt="Trailfinders have you covered" class="p-3 w-100">
              <img v-if="!step3Active"  class="img-fluid float-end p-3" src="https://cdn.trailfinders.com/3dauu2dhtm_travel-insurance-rating-category-and-year-5-colour-rgb.png?width=120" />
          </figure>

             
          <hgroup>
            <h3 v-if="!tripDetails.quoteType === 'BACKPACKER'" class="p-3">Trusted since 1970</h3>
          </hgroup>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-10 p-3 bg-light">
      <hr/>
            <h3 v-if="defaultSite.domain !== 'ie'" class="mb-0 text-center">Our three distinct policies at a glance</h3>
            <h3 v-else class="mb-0 text-center">Our distinct policies at a glance</h3>
            <h6 class="text-center text-small">All policies are underwritten by Hamilton Insurance DAC and backed by Trailfinders</h6>

          <div class="col-12 row mt-3 d-flex justify-content-center">
            <div class="text-dark mb-3 col-12 col-lg-4">
              <ul>
              <h3>Trailfinders Single Trip</h3>
              <li>
                <span>Defaqto 5 star rated.</span>
              </li>
              <li>
                <span v-if="defaultSite.domain !== 'ie'">
                  Cover from {{ cover.uk.coverFrom }}pp.
                </span>
                <span v-else>
                  Cover from {{ cover.ie.coverFrom }}pp.
                </span>
              </li>
              <li>Trip duration from 4 days to 12 months.</li>
              <li>
                <span v-if="defaultSite.domain === 'ie'">
                  {{ cover.ie.cancellation }} pp cancellation cover, with option to increase further.
                </span>
                <span v-else>
                  {{ cover.uk.cancellation }} pp cancellation cover, with option to increase further.
                </span>
              </li>
              <li>
                <span v-if="defaultSite.domain === 'ie'">
                  {{ cover.ie.medical }}
                </span>
                <span v-else>
                  {{ cover.uk.medical }}
                </span> medical expenses with 365/24/7 emergency assistance.
              </li>
              <li>
                <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.baggage }}</span>
                <span v-else>{{ cover.uk.baggage }}</span>pp baggage cover.
              </li>
              <li>
                <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.personalMoney }}</span>
                <span v-else>{{ cover.uk.personalMoney }}</span>pp personal money cover.
              </li>
              <li>
                <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.travelDelay }}</span>
                <span v-else>{{ cover.uk.travelDelay }}</span>pp travel delay cover.
              </li>
              <li>Wide range of sporting and adventurous activities included.</li>
              <li>21 day cooling off period - guaranteed same day refund.</li>
              </ul>
            </div>

            <div class="text-dark mb-3 col-12 col-lg-4">
              <ul>
              <h3>Trailfinders Annual Multi-Trip</h3>
              <li>
                <span>Defaqto 5 star rated.</span>
              </li>
              <li>Same cover limits as the Trailfinders Single Trip policy</li>
              <li>
                <span v-if="defaultSite.domain === 'ie'">
                  Cover from {{ cover.ie.annualCoverFrom }}pp, just 57 cents per day.
                </span>
                <span v-else>
                  Cover from {{ cover.uk.annualCoverFrom }}pp, just 55p per day.
                </span>
              </li>
              <li>Unlimited number of trips anywhere in the world.</li>
              <li>Up to 70 days cover on any one trip.</li>
              <li>28 days Winter Sports cover included free of charge.</li>
              <li>Wide range of sporting and adventurous activities included.</li>
              <li>Insured partner/ spouse and children covered even if travelling independently of one another.</li>
              <li>Business travel included.</li>
              <li>Children 18 & under insured free of charge.</li>
              <li>21 day cooling off period – guaranteed same day refund.</li>
            </ul>
            </div>

            <div class="text-dark col-12 col-lg-4" v-if="defaultSite.domain !== 'ie'">
              <ul>
              <h3>Trailfinders Backpacker <small> (max age 30) </small></h3>
              <li>Cover from {{ defaultSite.symbol }}15pp.</li>
              <li>Trip duration from 4 days to 24 months.</li>
              <li>
                <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.cancellation }}</span><span v-else>{{ cover.ukBackpacker.cancellation }}</span>pp cancellation cover, with option to extend up to {{ defaultSite.symbol }}50,000pp.
              </li>
              <li>
                Up to <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.medical }}</span><span v-else>{{ cover.ukBackpacker.medical }}</span> medical expenses with 365/24/7 emergency assistance and automatic cover for certain pre-existing medical conditions.
              </li>
              <li>Wide range of sporting and adventurous activities included.</li>
              <li>Volunteering, working holidays*, and trekking to 7,000 metres included.</li>
              <li>Temporary return home during period of cover.</li>
              <li>No need for proof of return flight.</li>
              <li>Take out or extend cover whilst travelling.</li>
              <li>21 day cooling off period - guaranteed same day refund.</li>
              <small>* Some exceptions apply.</small><br/>
            </ul>
            </div>
       
          </div>
    </div>


  </div>
</template>

<script>
import moment from "moment";
import { fetchQuote } from "@/services/api.js";
import { required, requiredIf } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { getUKCountries, getIECountries } from "@/services/stepsAttributes";
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import { cover } from '../amounts/cover'


export default {
  mixins: [validationMixin],
  props: ["defaultSite"],
  components: {
    DatePicker
  },
  
  data() {
    return {
      cover,
      tripDetails: {
        residence: "",
        durationString: "",
        destination: "",
        numberPeopleString: "",
        totalNumberOfPeople: 0,
        totalAdults: "",
        quoteType: "SINGLEG",
        fromDate: "",
        toDate: "",
        quoteInfoSingle: {},
        quoteInfoAnnual: {},
        quoteInfoBackpacker: {},
      },
      peopleAges: {},
      peopleCategory: {},
      numPeople: "",
      IERef:'',
      selectPeople: [
        { text: "Please select", value: null },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
        { text: "9", value: 9 },
        { text: "10 and more", value: 10 },
      ],
      showKids: false,
      showGroup: false,
      noAdults: 0,
      showResInfo: false,
      destinationOptions: [
        { text: "Area 1 - Europe", value: "1" },
        { text: "Area 2 - Australia and New Zealand", value: "2" },
        { text: "Area 3 - Worldwide excluding the USA & Canada (North America)", value: "3" },
        { text: "Area 4 - Worldwide including the USA & Canada (North America)", value: "4" },
      ],
      
      isActive: true,
      // validation & errors
      formNotValid: false,
      quoteError: false,
      error: {
        backpackerAge : false,
        ageLimit: false,
        over75: false,
        kidsLimit: false,
        only1Kid: false,
        max2Adults: false,
        noDates: false,
        ieRef : false
      },
      showFromDate: false,
      showToDate: false,
    };
  },
  validations : {
    dateFrom : {
      required: requiredIf(function () {
        return this.tripDetails.quoteType === "SINGLEG";
      }),
    },
    dateTo : {
      required: requiredIf(function () {
        return this.tripDetails.quoteType === "SINGLEG";
      }),
    },
    numPeople : { required },
    destinationSingle: { required : requiredIf(function () {
      return this.tripDetails.quoteType === "SINGLEG";
    })},

    peopleAges : {
      $each: {
        AGE: { required },
      },
    },
    IERef : { required : requiredIf(function () {
      return this.defaultSite.domain === 'ie'
    })}
  },
  created() {
    this.tripDetails.residence = this.setResidence;
  },
  mounted() {
    window.scroll({
      top: 0,
      behavior: "instant",
    });
  },
  beforeRouteEnter(_to, from, next) {
    next((vm) => {
      if (from.name === "Step2" || from.name === "Step2_KB") {
        vm.destinationSingle = vm.getStep1.destination;
        vm.numPeople = vm.getStep1.peopleAges.length;
        vm.onChangePeople(vm.numPeople);
        vm.tripDetails.quoteType = vm.getStep1.quoteType;
        vm.tripDetails.residence = vm.getStep1.residence;
        vm.quoteSingle.PREMIUM = 0
        vm.quoteAnnual.PREMIUM = 0
        vm.quoteBackpacker.PREMIUM = 0
        vm.quoteSingle.WINTERSPORT = '0'
        vm.quoteAnnual.WINTERSPORT = '0'
        vm.quoteBackpacker.WINTERSPORT = '0'
        vm.getStep1.peopleAges.forEach((age, index) => {
          vm.peopleAges[index].AGE = age.AGE
        })
      }
    });
  },
  updated() {
    this.tripDetails.destination = this.setDestination;
  },
  computed: {
    ...mapFields({
      destinationSingle: "quoteSingle.DESTINATION",
      dateFrom: "fromDateRaw",
      dateTo: "toDateRaw",
      dubSingle: "quoteSingle.DUBDISCOUNT",
    }),
    ...mapGetters({
      quoteSingle: "getQuoteSingle",
      quoteAnnual: "getQuoteAnnual",
      quoteBackpacker: 'getQuoteBackpacker',
      getStep1: "getStep1",
      fromDateRaw : "getFromDateRaw",
      toDateRaw : "getToDateRaw"

    }),
    isKBInternal() {
      return process.env.VUE_APP_INTERNAL === "true" ? true : false;
    },
    startDate() {
      let fromDate = this.fromDateRaw
      return moment(fromDate).format('YYMMDD');
    },
    endDate() {
      let endDate = this.toDateRaw
      return moment(endDate).format('YYMMDD');
    },
    getAges() {
      const arrAges = [{ text: "select age", value: null }];
      for (let k = 1; k <= 75; k++) {
        arrAges.push({ text: k.toString(), value: k });
      }
      arrAges.push({ text: "76+", value: 76 });
      return arrAges;
    },
    setDestination() {
      let destination = "";
      if (this.quoteSingle.DESTINATION === "") {
        destination = "Europe";
      }
      if (this.quoteSingle.DESTINATION === "1") {
        destination = "Europe";
      }
      if (this.quoteSingle.DESTINATION === "2") {
        destination = "Australia and New Zealand";
      }
      if (this.quoteSingle.DESTINATION === "3") {
        destination = "Worldwide excluding the USA & Canada (North America)";
      }
      if (this.quoteSingle.DESTINATION === "4") {
        destination = "Worldwide INCLUDING North America";
      }
      return destination;
    },
    setResidence() {
      let residence = "";
      if (this.defaultSite.domain === "ie") {
        residence = "Ireland (Eire)";
      } else {
        residence = "United Kingdom (inc CI & Isle of Man)";
      }
      return residence;
    },
    setCountries() {
      let countries = [];
      if (this.defaultSite.domain === "ie") {
        this.updateOption("INSDUB");
        countries = getIECountries();
        return countries;
      } else {
        this.updateOption("INSUK");
        countries = getUKCountries();
        return countries;
      }
    },
    travellingGroup() {
      let showGroup = Boolean;
      this.numPeople >= 10 ? (showGroup = true) : (showGroup = false);
      return showGroup;
    }
  },
  methods: {
    ...mapActions([
      "fetchQuote",
      "updateTripDetailsInfo",
      "updateGUID",
      "updateOption",
      "updatePremiumSingle",
      "updatePremiumAnnual",
      "updatePremiumBackpacker",
      "updateQuoteBackpacker",
      "updateDateFrom",
      "updateDateTo",
      "updatePeopleAges",
      "updateAdults",
      "updateChildren",
      "updateInfants",
      "updateStep1",
      "addAgesToQuotes",
      "addEduToQuotes",
      "updateQuoteBackpacker",
      "fetchQuoteInfoBackpacker",
      "fetchQuoteInfoSingle",
      "fetchQuoteInfoAnnual",
      "updateFromDateRaw",
      "updateToDateRaw",
      "getDateFromRaw",
      "getDateToRaw"
    ]),
    
    addYears(date, numOfYears) {
      let formattedDate = new Date(date)
      formattedDate.setDate(formattedDate.getDate()-1) ///needs to be 1 day less than a full 12 months on
      formattedDate.setFullYear(formattedDate.getFullYear() + numOfYears) // add on appropriate number of years based on policy type
      return formattedDate
    },

    policyEndDate() {
      //single max 12m
      // backpacker max 24m
      //we are currently allowing 24months to be put in for all policies
      if(this.tripDetails.quoteType === 'SINGLEG' && this.dateFrom){
        return this.addYears(this.dateFrom, 2)
      }else if(this.tripDetails.quoteType === 'BACKPACKER' && this.dateFrom){
        return this.addYears(this.dateFrom, 2)
      }
    },

    s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    },
    setGUID() {
      return (
        this.s4() +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        this.s4() +
        this.s4()
      );
    },
    showOver75(age) {
      if (age > 75) {
        this.error.over75 = true;
      } else {
        this.error.over75 = false;
      }
    },
    toggleResidence() {
      this.showResInfo = !this.showResInfo;
    },
    validateDateFrom() {
      const { $dirty, $error } = this.$v.dateFrom;
      return $dirty ? !$error : null;
    },
    validateDateTo() {
      const { $dirty, $error } = this.$v.dateTo;
      return $dirty ? !$error : null;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.tripDetails[name];
      return $dirty ? !$error : null;
    },
    validateAges(name, index) {
      const { $dirty, $error } = this.$v.peopleAges[name + index];
      return this.numPeople > 2 ? false : $dirty ? !$error : null;
    },
    validateNumPeople() {
      const { $dirty, $error } = this.$v.numPeople;
      return $dirty ? !$error : null;
    },
    validateIERef() {
      const { $dirty, $error } = this.$v.IERef;
      return $dirty ? !$error : null;
    },
    validateDestination() {
      const { $dirty, $error } = this.$v.destinationSingle;
      return $dirty ? !$error : null;
    },
    touchField(field) {
      if (field && typeof field.touch === "function") {
        field.touch();
      }
    },
    async onSubmit(event) {
      
      event.preventDefault();
      this.formNotValid = false;
      this.quoteError = false;
      this.$v.$touch();
      this.checkAges();
      this.checkIERef();
      this.updateQuoteBackpacker({ ...this.quoteSingle, COVERTYPE : 'BACKPACKER', PREMIUM : '0' })
  
      // Vuelidate
      if (this.$v.$invalid || this.formNotValid) {
        this.formNotValid = true;
        return;
      } else {
        // passed Vuelidate
          await this.checkDates();
          this.storeVuexValues();
          this.getAllQuotes();
      }
    },
    


  async getAllQuotes() {
    let a = moment(this.dateTo)
      let b = moment(this.dateFrom)
      const diff = a.diff(b, 'days') + 1
    let quotes = [this.quoteSingle,this.quoteAnnual,this.quoteBackpacker]
    if(diff > 70){
      quotes = [this.quoteSingle, this.quoteBackpacker]
    }
  if (quotes) {
    this.updatePeopleAges({ peopleAges: this.peopleAges });
    try {
      for (const quote of quotes) {
       
        let res = await fetchQuote(quote);
    
          if (quote.COVERTYPE === 'BACKPACKER') {
            if(res.status === 'OK'){
            this.updatePremiumBackpacker(res.premium.trim());
            this.fetchQuoteInfoBackpacker({ response: res });
            }else{
            this.updatePremiumBackpacker('0');
            }

          }
          if (quote.COVERTYPE === 'SINGLEG') {
            if(res.status === 'OK'){
            this.updatePremiumSingle(res.premium.trim());
            this.fetchQuoteInfoSingle({ response: res });
            }else{
              this.updatePremiumSingle('0');
            }

          }
          if (quote.COVERTYPE === 'ANNUALG') {
            if(res.status === 'OK'){
            this.updatePremiumAnnual(res.premium.trim());
            this.fetchQuoteInfoAnnual({ response: res });
            }else{
              this.updatePremiumAnnual('0');
            }
          }
        }
      

      this.isKBInternal
        ? this.$router.push("/step2_KB")
        : this.$router.push("/step2");

    } catch (error) {
      this.quoteError = true;
    }
  }
},

    storeVuexValues() {
      this.updateTripDetailsInfo({...this.tripDetails});
      this.updateGUID(this.setGUID());
      this.updateAdults(this.peopleCategory.ADULTS);
      this.updateChildren(this.peopleCategory.CHILDREN);
      this.updateInfants(this.peopleCategory.INFANTS);
      this.addAgesToQuotes({ peopleAges: this.peopleAges });
      this.addEduToQuotes({ peopleAges: this.peopleAges });
      const step1Obj = {};

      const fromDateFormatted = moment(this.dateFrom, "DD/MM/YYYY").format("YYMMDD");
      const toDateFormatted = moment(this.dateTo, "DD/MM/YYYY").format("YYMMDD");

      step1Obj.residence = this.tripDetails.residence;
      step1Obj.quoteType = this.tripDetails.quoteType;
      step1Obj.destination = this.destinationSingle;
      step1Obj.dateFrom = fromDateFormatted;
      step1Obj.dateTo = toDateFormatted;
      step1Obj.peopleAges = this.peopleAges;
      this.updateStep1(step1Obj);
    },
    onChangePeople(person) {
      const numPeople = Number(person || 0);
      this.updateTripDetailsInfo({...this.tripDetails, totalNumberOfPeople : numPeople})
      this.peopleAges = [...Array(numPeople).keys()].map(
        (i) => this.peopleAges[i] || {}
      );
      // this.addAgesToQuotes({ peopleAges: this.peopleAges })
    },
    checkDates() {
      
      const fromDateFormatted = moment(this.dateFrom, "DD/MM/YYYY").format("YYMMDD");
      const toDateFormatted = moment(this.dateTo, "DD/MM/YYYY").format("YYMMDD");
      const fromDate = this.dateFrom
      const toDate = this.dateTo

      if (this.dateFrom || this.dateTo === "") {
        this.error.noDates = true;
      }
      if (
        moment(this.startDate, "DD/MM/YYYY").isValid() === false ||
        moment(this.endDate, "DD/MM/YYYY").isValid() === false
      ) {
        this.formNotValid = true;
        return;
      }
      this.tripDetails.fromDate = fromDateFormatted;
      this.tripDetails.toDate = toDateFormatted;
      this.updateTripDetailsInfo({...this.tripDetails, 
                                    quoteInfoAnnual : this.quoteAnnual, 
                                    quoteInfoSingle: this.quoteSingle, 
                                    quoteInfoBackpacker : { ...this.quoteSingle, COVERTYPE : 'BACKPACKER', destination : this.destinationSingle }
                                     });
              
      this.updateDateFrom(fromDateFormatted);
      this.updateDateTo(toDateFormatted);
      this.updateFromDateRaw(fromDate);
      this.updateToDateRaw(toDate);
    },

    checkIERef () {
      if(this.defaultSite.domain !== 'ie'){
        return
      }else if(this.IERef){
        const pattern = /^r[a-zA-Z0-9]{5}$/i;
        pattern.test(this.IERef) ? this.error.ieRef = false : this.error.ieRef = true
        this.error.ieRef ? this.formNotValid = true : null
        return
      }
     return
    },

    checkAges() {
      let ageErrors = 0;
      let nAdults = 0;
      let nSeniors1 = 0;
      let nSeniors2 = 0;
      let nSeniors3 = 0;
      let nSeniors4 = 0;
      let nOlder = 0;
      let nChildren = 0;
      let nChildrenEdu = 0;
      let nBackpackers = 0;
      let nInfants = 0;
      let nTotal = 0;
      let peopleString = "";
      this.noAdults = 0;
      this.error.over75 = false;
      this.showKids = false;

      for (let i = 0; i < this.numPeople; i++) {
        const person = this.peopleAges[i]["AGE"];
   
         //* ********* INFANT 0 - 2
         if (person === 1) {
          nInfants++;
          nTotal++;
          peopleString += "Infant (<2 years)<br/>";
        }
        /// //********** CHILDREN
        if (person >= 2 && person <= 18) {
          nChildren++;
          nTotal++;
          peopleString += "Child (" + person + " years)<br/>";
        }
        //* ************** ADULT 14 - 30 cat a
        if (person >= 14 && person <= 30) {
          nBackpackers++;

          if( person > 18 ){
            nAdults++;
            this.noAdults += 1;
            nTotal++;
            peopleString += "Adult (" + person + " years)<br/>";
          }
        }
        //* ************** ADULT 31 - 49 cat b
        if (person >= 31 && person <= 49) {
          nSeniors1++;
          nTotal++;
          peopleString += "Adult (" + person + " years)<br/>";
          this.noAdults += 1;
        }
        //* *************** ADULT 50 - 66 cat c
        if (person >= 50 && person <= 66) {
          nSeniors2++;
          nTotal++;
          peopleString += "Adult (" + person + " years)<br/>";
          this.noAdults += 1;
        }
        //* *************** ADULT 67 - 70 cat d
        if (person >= 67 && person <= 70) {
          nSeniors3++;
          nTotal++;
          peopleString += "Senior (" + person + " years)<br/>";
          this.noAdults += 1;
        }
        //* *************** ADULT 71 - 75 cat e
        if (person >= 71 && person <= 75) {
          nSeniors4++;
          nTotal++;
          peopleString += "Senior (" + person + " years)<br/>";
          this.noAdults += 1;
        }

        if (person > 75) {
          nOlder++;
          nTotal++;
        }
      }

      if (nTotal === 0 || this.numPeople > nTotal) {
        // not all ages selected
        this.formNotValid = true;
        ageErrors++;
      } else {
        if (nOlder > 0) {
          this.error.over75 = true;
          ageErrors++;
        }

      if (this.tripDetails.quoteType === 'SINGLEG' && this.dateFrom && this.dateTo){
        ///this prevents a scenario where no prices come back
      let a = moment(this.dateTo)
      let b = moment(this.dateFrom)
      const diff = a.diff(b, 'days') + 1
        for (let i = 0; i < this.numPeople; i++) {
                const age = this.peopleAges[i]["AGE"];
                if((age < 14 || age > 30) && (diff > 365)){
                this.error.backpackerAge2 = true;
                ageErrors++;
                this.formNotValid = true;
                }   
            }
      }

      // if no errors then proceed
      if (ageErrors === 0) {
        this.peopleCategory.ADULTS = "";

        if (nAdults) {
          this.peopleCategory.ADULTS += `A${nAdults}`;
        }
        if (nSeniors1) {
          this.peopleCategory.ADULTS += `B${nSeniors1}`;
        }
        if (nSeniors2) {
          this.peopleCategory.ADULTS += `C${nSeniors2}`;
        }
        if (nSeniors3) {
          this.peopleCategory.ADULTS += `D${nSeniors3}`;
        }
        if(nSeniors4){
          this.peopleCategory.ADULTS += `E${nSeniors4}`;
        }
        this.peopleCategory.CHILDREN = nChildren + nChildrenEdu;
        this.peopleCategory.INFANTS = nInfants;
        this.tripDetails.numberPeopleString = peopleString;
        this.tripDetails.totalNumberOfPeople = nTotal;
        this.tripDetails.totalAdults = this.noAdults;
        this.tripDetails.backpackers = nBackpackers;
      } else {
    
        this.formNotValid = true;
      }
      }}}}

</script>
<style lang="scss">
@use "../assets/scss/_variables/variables" as vars;
@use "../assets/scss/_mixin/_mixin" as mixin;

.tf-vue-quote {
  z-index: 100;
  bottom: 0;
  left: 0;
}
select {
  box-shadow: none !important;
  border: none;
  border-bottom: 1.5px solid rgb(186, 186, 186);
}
input {
  box-shadow: none !important;
  background-color: rgba(0,0,0,0);
  border: none;
  border-bottom: 1.5px solid rgb(186, 186, 186);
}
select :focus-visible {
  outline: none !important;
  box-shadow: none !important;
  border: none;
  border-bottom: 1.5px solid rgb(186, 186, 186);
}
select :focus {
  outline: none !important;
  box-shadow: none !important;
  border: none;
  border-bottom: 1.5px solid rgb(186, 186, 186);
}
</style>
